module.exports = __webpack_public_path__ + "static/media/1.867e9b19.png";